import { ActionStatus } from './action-status.entity';

export interface ActionDisabledCondition {
    condition: boolean;
    tooltip: string;
    entitySpecificTooltip?: boolean;
    tooltipFallback?: string;
    tooltipOptions?: Record<string, string | number>;
}

export class UserAction {
    private actionStatus: ActionStatus;
    private readonly availableConditions: boolean[];
    private readonly disabledConditions: ActionDisabledCondition[];

    constructor(availableConditions: boolean[], disabledConditions: ActionDisabledCondition[]) {
        this.availableConditions = availableConditions;
        this.disabledConditions = disabledConditions;

        this.initActionStatus();
    }

    private initActionStatus(): void {
        const available: boolean = this.availableConditions.every(condition => condition);
        const disabled: boolean = this.disabledConditions.some(disabledCondition => disabledCondition.condition);

        if (!available) {
            this.actionStatus = ActionStatus.Unavailable;
        } else {
            this.actionStatus = disabled ? ActionStatus.NotActionable : ActionStatus.Actionable;
        }
    }

    public isAvailable(): boolean {
        return this.actionStatus !== ActionStatus.Unavailable;
    }

    public isDisabled(): boolean {
        return this.actionStatus === ActionStatus.NotActionable;
    }

    public isEnabled(): boolean {
        return this.actionStatus === ActionStatus.Actionable;
    }

    public getDisabledCondition(): ActionDisabledCondition | undefined {
        return this.disabledConditions.find(disabledCondition => disabledCondition.condition === true);
    }
}
